var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-price.j2"] = require( "macros/product-price.j2" );
dependencies["product-meta/afterpay/afterpay-message.j2"] = require( "product-meta/afterpay/afterpay-message.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-meta/price.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-price.j2", false, "product/templates/product-meta/price.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("price", t_1);
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"hidePricing")) {
var t_4;
t_4 = (lineno = 4, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.isSoldOut",false])) || (lineno = 4, colno = 61, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["quickshop.product.isSoldOut",false]));
frame.set("isSoldOut", t_4, true);
if(frame.topLevel) {
context.setVariable("isSoldOut", t_4);
}
if(frame.topLevel) {
context.addExport("isSoldOut", t_4);
}
output += "<div class=\"dom-product-meta-price\">\n\n        <p class=\"c-product-meta__price u-small--show\" data-qa-product-price>\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "isSoldOut")) {
output += "\n\n                <span class=\"c-product-meta__sold-out\">";
output += runtime.suppressValue((lineno = 12, colno = 57, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product-price-sold-out"])), env.opts.autoescape);
output += "</span>\n\n            ";
;
}
else {
output += "<span>\n                    ";
output += runtime.suppressValue((lineno = 18, colno = 41, runtime.callWrap(runtime.memberLookup((t_1),"displayPricing"), "price[\"displayPricing\"]", context, [runtime.contextOrFrameLookup(context, frame, "product"),runtime.contextOrFrameLookup(context, frame, "core")])), env.opts.autoescape);
output += "\n                </span>\n\n            ";
;
}
output += "\n\n        </p>";
if(!runtime.contextOrFrameLookup(context, frame, "isSoldOut")) {
env.getTemplate("product-meta/afterpay/afterpay-message.j2", false, "product/templates/product-meta/price.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
})});
}
output += "</div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-meta/price.j2"] , dependencies)